import { createDealerAxios } from 'src/factories/axios-factory';
import {AutoTraderValuation, CapValuationResponse, Valuation } from 'src/types/valuations';

const dealerBackendDealer = createDealerAxios(process.env.DealersApiUrl!);

const valuationService = {

  getValuations(affiliateId: number): Promise<Valuation[]> {
    const affId = affiliateId.toString();
    return new Promise<Valuation[]>((resolve, reject) => {
      dealerBackendDealer.get(`/valuations/${affId}`)
        .then(res => {
          if (res.status === 200) {
            // Use the setStatus function
            const valuations = setStatus(res.data as Valuation[]);
            resolve(valuations);
          } else {
            console.log("No valuations found!");
            reject("NO_VALUATIONS_FOUND");
          }
        })
        .catch(error => {
          console.log("Error fetching valuations:", error);
          reject("ERROR_FETCHING_VALUATIONS");
        });
    });
  },
  capValuation(capId: number, mileage: number, reg: string, year: number | undefined) {
    return new Promise<CapValuationResponse | null>((resolve, reject) => {
      dealerBackendDealer.get(
        `/cap-valuations?capId=${capId}&mileage=${mileage}&vehicleRegistration=${reg.toUpperCase().replace(" ", "")}&year=${year}`).then(res => {
          if (res.status === 200) {
            resolve(res.data as CapValuationResponse);
          }
        }).catch(error => {
          console.log("no valuations found!");
          resolve(null)
        })
    })
  },
  saveValuation(valuation: Valuation): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await dealerBackendDealer.post(
          `/valuation`, 
          valuation);        
        if (res.status === 200) {
          valuation = setStatus([valuation])[0];
          resolve(valuation); 
        } else {
          reject(new Error('Failed to save valuation'));
        }
      } catch (error) {
        reject(error);
      }
    });
  },
getAutoTraderValuation(aid: number, registration: string, odometerReadingMiles: number): Promise<AutoTraderValuation> {
  return new Promise<AutoTraderValuation>((resolve, reject) => {
    dealerBackendDealer.post(
      `/v3/valuations/autotrader`,
      {
        affiliateUserId: aid,
        vrm: registration,
        currentMileage: odometerReadingMiles,
      }
    )
    .then(res => {
      console.log("Auto Trader API response:", res);
      if (res.status === 200) {
        resolve(res.data as AutoTraderValuation);
      } else {
        reject("NO_AUTOTRADER_VALUATION_FOUND");
      }
    })
    .catch(error => {
      console.log("Error fetching Auto Trader valuation:", error);
      reject("ERROR_FETCHING_AUTOTRADER_VALUATION");
    });
  });
},
};
function setStatus(valuations: Valuation[]): Valuation[] {
  const currentMonth = new Date().getMonth();
  const currentYear = new Date().getFullYear();

  return valuations.map(valuation => {
    if (valuation.created) {
      const createdDate = new Date(valuation.created);
      const isSameMonth =
        createdDate.getMonth() === currentMonth &&
        createdDate.getFullYear() === currentYear;

      valuation.status = isSameMonth ? 1 : -1;
    } else {
      valuation.status = -1; // Handle null `created` dates
    }

    return valuation;
  });
}

export default valuationService;
